const templateUrl = require('./paymetric.html');

module.exports = {
  controller: require('./paymetric.controller'),
  templateUrl: templateUrl,
  bindings: {
    onFinished: '&ogOnFinished',
    payment: '<ogPayment'
  }
};
